import React from "react";
export default function WorkdocRolesRole({ role = {}, onClick }) {
  const date = role.dateto ? new Date(role.dateto) : null;

  const truncateName = (name = "") => {
    return name
      .split(" ")
      .reduce((acc, part, idx) => {
        if (part) {
          if (idx) {
            acc.push(part[0] + ".");
          } else {
            acc.push(part);
          }
        }
        return acc;
      }, [])
      .join(" ");
  };

  let completed = role.completed;
  let editable = !role.completed;

  let itemClasses = ["workdoc-role-item"];
  if (completed) itemClasses.push("completed");
  if (editable) itemClasses.push("editable");

  const onItemClick = () => {
    if (editable && onClick) {
      onClick();
    }
  };

  return (
    <div className={itemClasses.join(" ")} onClick={onItemClick}>
      {completed && <i className="completed-icon fa fa-check-circle"></i>}
      {role.structurename && (
        <div className="workdoc-role-item-structure">{role.structurename}</div>
      )}
      {role.membername ? (
        <div className="workdoc-role-item-name">
          {truncateName(role.membername)}
        </div>
      ) : (
        <div className="workdoc-role-item-position">{role.positionname}</div>
      )}
      {date && (
        <div className="workdoc-role-item-date">до {date.toLocaleString()}</div>
      )}
    </div>
  );
}
